import React from "react"
import styled, { css } from "styled-components"
import { responsive } from "buoy-theme"
import ProfileSelect from "./components/ProfileSelect"
import MobileProfileSelect from "./components/MobileProfileSelect"
import percentCompleteWrapper from "./components/PercentComplete"
import DashboardAuth from "../../../dashboard/components/DashboardAuth"
import PrivacyCard from "./components/PrivacyCard"
import { SwitcherCards } from "../ProfileCards"

const DashboardSwitcherCard = styled.div`
  display: flex;
  ${responsive("max-width", "384px", "384px", "100%", "100%", "100%")};
  ${responsive("width", "auto", "auto", "100%", "100%", "100%")};
  ${responsive("margin-top", "0", "0", "24px", "24px", "16px")};
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const SwitcherContainer = styled.div`
  position: relative;
  width: 100%;
  ${props => props.sticky ? css`
    ${responsive("position", "sticky", "sticky", "relative", "relative", "relative")};
    ${responsive("top", "129px", "129px", "unset", "unset", "unset")};
  ` : ""};
`

const ProfileSwitcher = ({
  select,
  profiles,
  dashboard,
  selectedProfile,
  goToProfile,
  percentsComplete,
  collapse,
}) => (
  <React.Fragment>
    {dashboard ? (
      <ProfileSelect
        {...selectedProfile}
        selected={true}
        onClick={goToProfile}
        selectedProfile={selectedProfile}
        percentsComplete={percentsComplete}
        collapse={collapse}
        dashboard
      />
    ) : (
      profiles.map((p, i) => (
        <ProfileSelect
          {...p}
          key={p.id}
          selected={selectedProfile && selectedProfile.id === p.id}
          onClick={select(i)}
          selectedProfile={selectedProfile}
          percentsComplete={percentsComplete}
          collapse={collapse}
        />
      ))
    )}
  </React.Fragment>
)

class SwitcherWrapper extends React.Component {
  state = {
    sticky: false
  }

  componentDidMount = () => {
    window.addEventListener("scroll", this.setSticky)
  }

  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.setSticky)
  }

  setSticky = () => {
    let sticky = window.scrollY > 67 ? true : false
    this.setState({ sticky: sticky })
  }

  render() {
    const { sticky } = this.state
    const { showPrivacy, dashboard, selectedProfile, loggedIn, signedUp, profiles, select } = this.props
    let showProfDetails = selectedProfile || (loggedIn === "ok" && !signedUp)
    return (
      <React.Fragment>
        {dashboard ? (
          <SwitcherContainer sticky={sticky && showProfDetails}>
            <DashboardSwitcherCard>
              {showProfDetails ? (
                <ProfileSwitcher dashboard {...this.props} collapse={sticky} />
              ) : (
                <DashboardAuth {...this.props} />
              )}
            </DashboardSwitcherCard>
            {showPrivacy && (
              <PrivacyCard />
            )}
          </SwitcherContainer>
        ) : (
          <React.Fragment>
            <MobileProfileSelect
              selected={selectedProfile}
              profiles={profiles}
              select={select}
              />
            <SwitcherCards>
              <SwitcherContainer sticky={sticky}>
                <ProfileSwitcher {...this.props} />
              </SwitcherContainer>
            </SwitcherCards>
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}

const Switcher = percentCompleteWrapper(SwitcherWrapper)

export { Switcher as default }



// WEBPACK FOOTER //
// ./assets/common/components/ProfileSwitcher/index.js